/**
 * Entry point for running the application.
 * Must export an object with a start() method.
 *
 * Since this is a component, the entry point is only used for running it in isolation.
 * When consumed by a page or feature, the entry point will be defined by the consumer.
 */
import '@core/style-guide/src/scss/macys-base.scss';
let $ = require('jquery');
import ProductPool from './src/int-vue-productpool';

// let Vue = require('./server/dev/lib/vue/dist/vue.common.dev.js');
// import {Carousel, Slide} from './server/dev/lib/vue-carousel';
// import VueRouter from './server/dev/lib/vue-router/dist/vue-router.min.js';
// Vue.use(VueRouter);
// import './src/scss/int-vue-productpool.scss';

window.$ = $;
const App = {
  start() {

    // this.init();
    const component = new ProductPool('#int-vue-productpool-main', {
      opt: 'val'
    });

    component.init();

  },


};
window.INTPRODUCTPOOL = App;
export default App;


// WEBPACK FOOTER //
// /Users/elizabeth.chen/Documents/Work/2/int-vue-productpool/app.js